const links = [
  { href: '/support', label: 'Support', external: false },
  { href: 'https://github.com/ThatCatDev/tanrenai', label: 'GitHub', external: true },
  { href: 'https://github.com/ThatCatDev/tanrenai/releases', label: 'Releases', external: true },
  { href: 'https://github.com/ThatCatDev/tanrenai/issues', label: 'Issues', external: true },
];

function Footer() {
  return (
    <footer class="border-t border-border py-10">
      <div class="container flex justify-between items-center max-md:flex-col max-md:gap-4 max-md:text-center">
        <div class="flex items-center gap-2 text-[0.8rem] text-muted">
          <img src="/logo.png" alt="" class="h-5 w-5 opacity-60" />
          <span>
            TanrenAI — forged by{' '}
            <a
              href="https://github.com/ThatCatDev"
              target="_blank"
              rel="noopener"
              class="text-accent hover:underline"
            >
              ThatCatDev
            </a>
          </span>
        </div>
        <div class="flex gap-6">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              target={l.external ? '_blank' : undefined}
              rel={l.external ? 'noopener' : undefined}
              class="text-muted text-[0.8rem] transition-colors hover:text-fg hover:no-underline"
            >
              {l.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
